import { Outlet } from 'react-router-dom'
import { TopBar } from './top-bar'

/**
 * Two layers: an off-white page (`--background`, Kinetic grey/200) and white
 * surfaces on top of it. Navigation lives in the sticky top bar; there is no
 * sidebar and no command palette, so every route is one click from any screen.
 */
export function AppShell() {
  return (
    <div className="flex min-h-dvh w-full flex-col overflow-x-clip bg-[color:var(--background)] text-[color:var(--foreground)]">
      <TopBar />
      <main className="mx-auto w-full min-w-0 max-w-[1600px] flex-1 px-4 py-5 md:px-8 md:py-6 pl-[max(1rem,env(safe-area-inset-left))] pr-[max(1rem,env(safe-area-inset-right))] pb-[max(1.25rem,env(safe-area-inset-bottom))]">
        <Outlet />
      </main>
    </div>
  )
}
